import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import HrResumeVisibilityContainer from '../../containers/employeemng/personal/HrResumeVisibilityContainer';

// 사원 이력 항목별 공개 권한 - 관리자 전용. bito 4단계(2026-10-20).
const HrResumeVisibilityPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="인사관리/사원관리/이력 공개 설정" icon="user" />
      <HrResumeVisibilityContainer />
    </>
  );
};

export default HrResumeVisibilityPage;
